import { render } from "./CombatLogOverview.vue?vue&type=template&id=7579fcc2"
import script from "./CombatLogOverview.vue?vue&type=script&lang=js"
export * from "./CombatLogOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__